import { render, staticRenderFns } from "./vuex-icon-checkbox.vue?vue&type=template&id=fb2e74a2&scoped=true"
import script from "./vuex-icon-checkbox.vue?vue&type=script&lang=js"
export * from "./vuex-icon-checkbox.vue?vue&type=script&lang=js"
import style0 from "./vuex-icon-checkbox.vue?vue&type=style&index=0&id=fb2e74a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb2e74a2",
  null
  
)

export default component.exports